import { ELSButton, ELSIcon } from 'components/common/els';
import { EDCollectionConfig } from './constants';
import { EDRow } from './EmergencyDepartment';

export interface EmergencyDepartmentTableProps {
  config: EDCollectionConfig;
  rows: EDRow[];
  isAuthor: boolean;
  onEdit: VoidFunction;
}

const EmergencyDepartmentTable = ({ config, rows, isAuthor, onEdit }: EmergencyDepartmentTableProps) => (
  <div className="emergency-department__collection">
    <div className="emergency-department__collection-header">
      <span className="emergency-department__collection-title">{config.title}</span>
      {isAuthor && rows.length > 0 && (
        <button className="emergency-department__collection-edit" type="button" onClick={onEdit} aria-label={`Edit ${config.title}`}>
          <ELSIcon name="edit" size="1x" />
        </button>
      )}
    </div>

    {rows.length > 0 && (
      <table className="emergency-department__table">
        <thead>
          <tr>
            {config.columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={rowIndex}>
              {config.columns.map((column) => (
                <td key={column.key}>{String(row[column.key] ?? '').trim()}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    )}

    {isAuthor && rows.length === 0 && (
      <ELSButton
        className="emergency-department__add-btn"
        text="Add"
        type="secondary"
        iconName="add-circle"
        iconPrefix="hmds"
        iconPosition="right"
        iconSize="1x"
        onClick={onEdit}
      />
    )}

    <div className="emergency-department__collection-divider" aria-hidden="true" />
  </div>
);

EmergencyDepartmentTable.displayName = 'EmergencyDepartmentTable';
export default EmergencyDepartmentTable;
